import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_category_video.breadcrumb.category_video_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_category_video.breadcrumb.category_video_label2'),
    link: '/application/videos-channel',
  },
  {
    label: t('pages.application_category_video.breadcrumb.category_video_label3'),
  },
];
